<div class="container-fluid content-info">
  <div class="row">
    <!-- Tarjeta Busqueda -->
    <div class="col-12 col-md-3 col-lg-2 mb-3 p-1">
      <div class="card rounded-0">
        <div class="card-header bg-dark rounded-0">
          <span class="text-white">Formulario</span>
        </div>
        <div class="card-body" id="adjustSearch">
          <form id="searchFormData">
            <button type="button" onclick="identifyExecute()"
            class="btn btn-sm btn-primary rounded-0 mb-3 w-100"
            id="btnExecute">
              <em class="bi bi-search me-1"></em>
              <span class="me-1">Buscar</span>
            </button>

          </form>
        </div>
      </div>
    </div>
    <!-- Tarjeta Resultado -->
    <div class="col-12 col-md-9 col-lg-10 mb-3 p-1">
      <div class="card rounded-0 p-0">
        <div class="card-header bg-dark rounded-0 d-flex justify-content-between align-items-center">
          <span class="text-white">Resultado</span>

          <!-- Botones alineados a la derecha -->
          <div class="d-flex">
            <button type="button" class="btn btn-sm btn-light rounded-0 me-1">
              <i class="bi bi-justify"></i>
              <span class="d-none">Tabla</span>
            </button>
            <button type="button" class="btn btn-sm btn-warning rounded-0 me-1">
              <i class="bi bi-table"></i>
              <span class="d-none">Datos</span>
            </button>
            <button type="button" class="btn btn-sm btn-danger rounded-0 me-1">
              <i class="bi bi-list"></i>
              <span class="d-none">Tarjeta</span>
            </button>
          </div>
        </div>
        <div class="card-body p-3" id="adjustResult">
          <table id="tableResult" class="table table-bordered text-center m-0 w-100 h-100">
            <thead class="d_none">
              <tr>
                <th *ngFor="let column of pageColumn">{{ column }}</th>
              </tr>
            </thead>
            <tbody class="d_none">
              <tr *ngIf="pageData.length === 0">
                <td [attr.colspan]="pageColumn.length" class="text-center">
                  No hay datos para mostrar
                </td>
              </tr>
              <tr *ngFor="let row of pageData">
                <td *ngFor="let column of pageColumn">
                  {{ getColumnValue(row, column) }}
                </td>
              </tr>
            </tbody>
          </table>
          <table id="tableData" class="table table-bordered text-center m-0 w-100 h-100 d-none">
            <thead class="d_none">
              <tr>
                <th *ngFor="let column of pageColumn">{{ column }}</th>
              </tr>
            </thead>
            <tbody class="d_none">
              <tr *ngIf="pageData.length === 0">
                <td [attr.colspan]="pageColumn.length" class="text-center">
                  No hay datos para mostrar
                </td>
              </tr>
              <tr *ngFor="let row of pageData">
                <td *ngFor="let column of pageColumn">
                  {{ getColumnValue(row, column) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Tarjeta Trazabilidad -->
    <div class="col-12 col-md-3 col-lg-2 mb-3 d-none">
      <div class="card rounded-0">
        <div class="card-header bg-dark rounded-0">
          <span class="text-white">Trazabilidad</span>
        </div>
        <div class="card-body" id="adjustTrace">
          <table id="identifyTblTrace"
          class="table table-bordered text-center">
            <thead>
              <tr>
                <th>Valor</th>
                <th>Accion</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  No hay datos para mostrar
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>












<!-- Modal: Servicio Inaccesible -->
<div class="modal fade" id="modalAlertAvailable"
name="modalAlertAvailable" tabindex="-1"
aria-hidden="true" aria-labelledby="modalAlertData"
data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content rounded-0">
      <div class="modal-header justify-content-center rounded-0 border-0 bg-danger">
        <h4 class="modal-title" id="modalAlertData">
          <span class="text-white">Servicio Inaccesible</span>
        </h4>
      </div>
      <div class="modal-body text-center">
        <p class="text-danger mb-2">
          <span>
            Estamos experimentando problemas con nuestro servicio.
          </span>
        </p>
        <p class="text-dark mb-2">
          <span>
            Nuestro equipo está trabajando para resolver la situación
            y permitir que continúes con tu proceso sin inconvenientes.
            Te agradecemos tu paciencia y intentalo de nuevo más tarde.
          </span>
        </p>
      </div>
      <div class="modal-footer justify-content-center">
        <button class="btn btn-md btn-success rounded-0"
        type="button" data-dismiss="modal">
          <span>Aceptar</span>
        </button>
        <button type="button" class="btn btn-md btn-primary rounded-0">
          <span>Soporte Técnico</span>
        </button>
      </div>
    </div>
  </div>
</div>
